import { jsx as _jsx } from "react/jsx-runtime";
// @ts-expect-error This library is not yet typed
import { UIAvatar } from 'ui-addon-avatars';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UILink from 'UIComponents/link/UILink';
import { useIsIdle } from '../utils/useIsIdle';
import TruncateDiv from './TruncateDiv';
import { KOALA } from 'HubStyleTokens/colors';
import styled from 'styled-components';
const AvatarContainer = styled.div.withConfig({
  displayName: "AvatarCell__AvatarContainer",
  componentId: "jk0w1c-0"
})(["height:24px;width:24px;"]); // HACK: this targets the inner div `UIAvatar` uses for its avatar to change the
// position property. I don't see any other way to do this looking at the source.
// This is used to keep it from overlapping the sticky checkbox, so if we drop that
// feature we can remove this hack too.
// See https://git.hubteam.com/HubSpot/ui-addon-avatars/blob/master/static/js/UIAvatarDisplay/baseStyledComponents/AvatarWrapper.js

const StyledAvatar = styled(UIAvatar).withConfig({
  displayName: "AvatarCell__StyledAvatar",
  componentId: "jk0w1c-1"
})(["position:static;div{position:static;}"]);
const AvatarPlaceholder = styled.div.withConfig({
  displayName: "AvatarCell__AvatarPlaceholder",
  componentId: "jk0w1c-2"
})(["background-color:", ";border-color:transparent;border-radius:50%;width:100%;height:100%;"], KOALA);
export const AvatarCell = ({
  type,
  id,
  href,
  displayName,
  onClick,
  children,
  className
}) => {
  const isIdle = useIsIdle();
  const lookupProp = {
    [type]: type === 'hubSpotUserEmail' ? id : Number(id)
  };
  const avatar = isIdle && id ? /*#__PURE__*/_jsx(StyledAvatar, Object.assign({
    "data-test-id": "avatar",
    type: type
  }, lookupProp, {
    displayName: displayName,
    size: "xs",
    className: className
  })) : /*#__PURE__*/_jsx(AvatarPlaceholder, {
    "data-test-id": "avatar-placeholder"
  });
  const isClickable = href || onClick;
  return /*#__PURE__*/_jsx(UIMediaObject, {
    align: "center",
    itemLeft: id && avatar,
    MediaLeft: AvatarContainer,
    children: /*#__PURE__*/_jsx(TruncateDiv, {
      children: isClickable ? /*#__PURE__*/_jsx(UILink, {
        role: "link",
        href: href,
        onClick: onClick,
        children: children
      }) : children
    })
  });
};
export default AvatarCell;